import React from "react";
import { Button } from "@mui/material";
import { WhenBuilder } from "../WhenBuilder";
import type { RuleComponentProps } from "./types";

const DEFAULT_WHEN_TRUE = { true: true as const };

export const RuleAll: React.FC<RuleComponentProps> = ({
    value,
    onChange,
    depth,
    evaluationDomain,
    declaredDerivedAttributeNames = [],
}) => {
    const conditions = value?.all?.conditions ?? [];

    const updateCondition = (index: number, condition: import("../../../../../../types/resolver").WhenDto | null) => {
        const next = conditions.slice();
        if (condition == null) {
            next.splice(index, 1);
            if (next.length === 0) next.push(DEFAULT_WHEN_TRUE);
        } else {
            next[index] = condition;
        }
        onChange({ all: { conditions: next } });
    };

    const addCondition = () => {
        onChange({ all: { conditions: [...conditions, DEFAULT_WHEN_TRUE] } });
    };

    return (
        <>
            {conditions.map((cond, i) => (
                <WhenBuilder
                    key={`condition-${depth}-${i}`}
                    value={cond}
                    onChange={(c) => updateCondition(i, c)}
                    depth={depth + 1}
                    evaluationDomain={evaluationDomain}
                    declaredDerivedAttributeNames={declaredDerivedAttributeNames}
                />
            ))}
            <Button size="small" variant="outlined" onClick={addCondition}>
                Add condition
            </Button>
        </>
    );
};
